<template>
  <div>
    <VueSignaturePad 
      ref="signaturePad" 
      :class="$style.signature" 
      height="150px"
      :options="{ onEnd }"
    />
    <div :class="$style.buttons">
      <button @click.prevent="clear">{{$t('clear')}}</button>
      <button @click.prevent="undo">{{$t('undo')}}</button>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    onEnd() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/svg+xml');
      this.$emit('update:value', isEmpty ? null : data);
    }
  }
};
</script>

<style lang="scss" module>
.signature {
  border-bottom: solid black 1px;
  margin-bottom: 10px;
}

.buttons {
  display: flex;
  justify-content: flex-start;

  & > * {
    margin-right: 4px;
  }
}
</style>
